import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

export const SectionMessageContainer = styled.div`
    margin-top: ${token('space.200', '16px')};
`;
